// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.develope {
  color: white;
  font-size: 12px;
  flex-direction: column;
  text-align: center;
  -webkit-text-size-adjust: none;
          text-size-adjust: none;
  padding: 8px 4px;
  background: var(--ion-color-secondary);
}

.container {
  display: flex;
  height: 100vh;
  width: 100%;
  background: #231F20;
  color: white;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.container span {
  font-size: 12px;
  padding: 0 4em;
  text-align: center;
}
.container img {
  width: 450px;
}

ion-content {
  --background: linear-gradient(180deg, #FF7000 0%, #C77100 100%);
  position: relative;
}
ion-content .background-opacity {
  background-image: url("/assets/images/background.png");
  background-repeat: no-repeat;
  background-position: center;
  height: 90vh;
  opacity: 0.1;
  width: 100%;
}
ion-content .container {
  top: 0;
  width: 100%;
  height: 90vh;
  padding-top: 2em;
  position: absolute;
}
ion-content .container .header-container {
  z-index: 100;
  padding: 1em;
  text-align: center;
}
ion-content .container .header-container img {
  width: 84px;
}
ion-content .container .header-container h1 {
  color: white;
  margin: 8px 0 0 0;
  font-weight: bold;
}
ion-content .container .form-container {
  padding: 2em;
}
ion-content .container .form-container ion-list {
  border-radius: 30px;
  padding: 1em;
}
ion-content .container .form-container ion-list .icon-container {
  padding: 0 1em;
  text-align: center;
}
ion-content .container .form-container ion-list .icon-container img {
  width: 56px;
}
ion-content .container .form-container ion-list ion-label {
  --color: #3B3E51;
  padding-left: 1em;
  padding-top: 0.8em;
}
ion-content .container .form-container ion-list .button-group {
  margin-top: 30px;
  margin-bottom: 30px;
  padding-right: 1em;
  padding-left: 1em;
}
ion-content .container .form-container ion-list .login-container {
  text-align: center;
  margin-bottom: 30px;
}
ion-content .container .form-container ion-list .login-container a {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;UAAA,sBAAA;EACA,gBAAA;EACA,sCAAA;AACJ;;AAEA;EACI,aAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AACJ;AACI;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AACR;AAEI;EACI,YAAA;AAAR;;AAIA;EACI,+DAAA;EACA,kBAAA;AADJ;AAGI;EACI,sDAAA;EACA,4BAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADR;AAII;EACI,MAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAFR;AAIQ;EACI,YAAA;EACA,YAAA;EACA,kBAAA;AAFZ;AAIY;EACI,WAAA;AAFhB;AAKY;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;AAHhB;AAOQ;EACI,YAAA;AALZ;AAOY;EACI,mBAAA;EACA,YAAA;AALhB;AAOgB;EACI,cAAA;EACA,kBAAA;AALpB;AAOoB;EACI,WAAA;AALxB;AASgB;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AAPpB;AAUgB;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AARpB;AAWgB;EACI,kBAAA;EACA,mBAAA;AATpB;AAWoB;EACI,qBAAA;AATxB","sourcesContent":[".develope {\n    color: white;\n    font-size: 12px;\n    flex-direction: column;\n    text-align: center;\n    text-size-adjust: none;\n    padding: 8px 4px;\n    background: var(--ion-color-secondary);\n}\n\n.container {\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    background: #231F20;\n    color: white;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n\n    span {\n        font-size: 12px;\n        padding: 0 4em;\n        text-align: center;\n    }\n\n    img {\n        width: 450px;\n    }\n}\n\nion-content {\n    --background: linear-gradient(180deg, #FF7000 0%, #C77100 100%);\n    position: relative;\n\n    .background-opacity {\n        background-image: url(\"/assets/images/background.png\");\n        background-repeat: no-repeat;\n        background-position: center;\n        height: 90vh;\n        opacity: 0.1;\n        width: 100%;\n    }\n\n    .container {\n        top: 0;\n        width: 100%;\n        height: 90vh;\n        padding-top: 2em;\n        position: absolute;\n\n        .header-container {\n            z-index: 100;\n            padding: 1em;\n            text-align: center;\n\n            img {\n                width: 84px;\n            }\n\n            h1 {\n                color: white;\n                margin: 8px 0 0 0;\n                font-weight: bold;\n            }\n        }\n\n        .form-container {\n            padding: 2em;\n\n            ion-list {\n                border-radius: 30px;\n                padding: 1em;\n\n                .icon-container {\n                    padding: 0 1em;\n                    text-align: center;\n\n                    img {\n                        width: 56px;\n                    }\n                }\n\n                ion-label {\n                    --color: #3B3E51;\n                    padding-left: 1em;\n                    padding-top: 0.8em;\n                }\n\n                .button-group {\n                    margin-top: 30px;\n                    margin-bottom: 30px;\n                    padding-right: 1em;\n                    padding-left: 1em;\n                }\n\n                .login-container {\n                    text-align: center;\n                    margin-bottom: 30px;\n\n                    a {\n                        text-decoration: none;\n                    }\n                }\n            }\n        }\n    }\n\n} "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
